﻿import React, { useState, useEffect } from 'react';
//import Splitter, { Item } from 'devextreme-react/splitter';

export default function LayoutTester() {
    
    return (
        <div>

            {/*
            <Splitter id="splitter">
                <Item resizable={true}
                    size="10rem"
                    minSize="3rem" />

                <Item resizable={true} />

            </Splitter>
            */}
        </div>
    );

}

